import { baseErrorHandler } from '@queries/baseErrorHandler';
import i18n from '@service/I18nService';
import { $api } from '@service/RequestService';
import { getDebitsBody } from '@utils/helper/getSearchAndDownloadBodyAllTables';
import { useMutation } from 'react-query';

export const useDebtWithPaymentExcel = () =>
  useMutation(
    async (data: { size: number; searchObj: any }) => {
      const res = await $api.post(
        `/v1/debt/with-payment/excel?lang=${i18n.language?.toUpperCase()}`,
        getDebitsBody(data?.searchObj)
      );

      return res.data;
    },
    {
      onError: baseErrorHandler
    }
  );
